import {CatalogIcon} from '@icons/CatalogIcon';
import {ReactComponent as TruckDisksIcon} from '@icons/pruducts/TruckDisksIcon.svg';
import {IconProps} from '@icons/types';
import TyrePicture from '../../assets/images/menu/Tire.png';
import DisksPicture from '../../assets/images/menu/Disk.png';
import TruckTyrePicture from '../../assets/images/menu/TruckTire.png';
import SpecialTyrePicture from '../../assets/images/menu/SpecialTire.png';
import MotoTyrePicture from '../../assets/images/menu/MotoTire.png';
import QuadroTyrePicture from '../../assets/images/menu/QuadroTire.png';
import WarehousePicture from '../../assets/images/menu/Suppliers.png';
import TruckDisksPicture from '../../assets/images/menu/TruckDisks.png';
import {Home} from '../../icons';
import {INavConfig, INavMobile} from './types';

export const screens: INavMobile[] = [
    {
        path: '/tires',
        label: 'Шины',
        Icon: () => <img src={TyrePicture} alt=""/>
    }, {
        path: '/disks',
        label: 'Диски',
        Icon: () => <img src={DisksPicture} alt=""/>
    }, {
        path: '/truck_tires',
        label: 'Грузовые шины',
        Icon: () => <img src={TruckTyrePicture} alt=""/>
    }, {
        path: '/truck_disks',
        label: 'Грузовые диски',
        Icon: () => <img src={TruckDisksPicture} alt=""/>
    }, {
        path: '/special_tyres',
        label: 'Спецшины',
        Icon: () => <img src={SpecialTyrePicture} alt=""/>
    }, {
        path: '/moto_tires',
        label: 'Мотошины',
        shortLabel: 'Мото',
        Icon: () => <img src={MotoTyrePicture} alt=""/>
    }, {
        path: '/quadro_tires',
        label: 'Квадрошины',
        shortLabel: 'Квадро',
        Icon: () => <img src={QuadroTyrePicture} alt=""/>
    },
    {
        path: '/suppliers',
        label: 'Поставщики',
        Icon: () => <img src={WarehousePicture} alt=""/>
    },
];

/** Пункты верхнего меню: каталог + отдельный роут «Тарифы» (не показываем в сетке /catalog) */
export const headerNavLinks: INavConfig[] = [
    ...screens.map(({path, label, shortLabel}) => ({path, label, shortLabel})),
    {path: '/tariffs', label: 'Тарифы'},
];

/**
 * Нижние табы (каталог): только публичные разделы.
 * Отдельный таб «Подписка» сюда не добавляем — страница в кабинете, путь через
 * burger → sidebarConfig (SUB-007 / план оркестрации); расширять mobileScreens только по явному продуктовому ТЗ.
 */
export const mobileScreens: INavMobile[] = [
    {
        path: '/',
        label: 'Главная',
        Icon: ({width, color, height, ...props}: IconProps) =>
            <Home width={width} height={height} color={color} {...props} />
    },
    {
        path: '/catalog',
        label: 'Каталог',
        Icon: ({width, color, height, ...props}: IconProps) =>
            <CatalogIcon width={width} height={height} color={color} {...props} />
    },
    {
        path: '/profile',
        label: 'Профиль',
        Icon: ({width, color, height, ...props}: IconProps) =>
            <Home width={width} height={height} color={color} {...props} />
    },
];
